module.exports = require("core-js-pure/features/object/define-properties");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/object/define-properties.js
// module id = 486
// module chunks = 13